"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var MonacoContainer_1 = __importDefault(require("./MonacoContainer"));

var monaco = __importStar(require("monaco-editor"));

var MonacoEditor = function MonacoEditor(_a) {
  var width = _a.width,
      height = _a.height,
      loading = _a.loading,
      value = _a.value,
      language = _a.language,
      editorOptions = _a.editorOptions,
      editorDidMount = _a.editorDidMount,
      onChange = _a.onChange,
      controlled = _a.controlled;

  var _b = react_1.useState(false),
      isEditorReady = _b[0],
      setIsEditorReady = _b[1];

  var previousValue = react_1.useRef(value);
  var containerRef = react_1.useRef(null);
  var editorRef = react_1.useRef(null);

  var createEditor = function createEditor() {
    if (!containerRef || !containerRef.current) {
      return;
    }

    var resultOptions = __assign({
      value: value,
      language: language
    }, editorOptions);

    editorRef.current = monaco.editor.create(containerRef.current, resultOptions);
    editorDidMount(editorRef.current.getValue.bind(editorRef.current), editorRef.current);
    setIsEditorReady(true);
    editorRef.current.onDidChangeModelContent(function (ev) {
      var currentValue = editorRef.current.getValue();

      if (currentValue !== previousValue.current && !(ev.isUndoing || ev.isRedoing)) {
        previousValue.current = currentValue;

        if (onChange) {
          onChange(ev, currentValue);
        }
      }
    });
  };

  react_1.useEffect(function () {
    if (editorOptions && editorOptions.readOnly && editorRef.current && editorRef.current.getValue() !== value) {
      editorRef.current.setValue(value);
    } else if (editorRef.current && editorRef.current.getValue() !== value) {
      editorRef.current.executeEdits("", [{
        range: editorRef.current.getModel().getFullModelRange(),
        text: value
      }]);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [value]);
  react_1.useEffect(function () {
    createEditor(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return react_1.default.createElement(MonacoContainer_1.default, {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    reference: containerRef
  });
};

exports.default = MonacoEditor;